module.exports = "f90e7c74f3873c2771563c72b4970a16.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/lantern-edge-R.png
// module id = 56
// module chunks = 0